// extracted by mini-css-extract-plugin
module.exports = {"text":"_8e474ad"};